"use strict";

(self.webpackChunkuklash = self.webpackChunkuklash || []).push([ [ 78 ], {
  78: function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
    __webpack_require__.r(__webpack_exports__), __webpack_exports__.default = void (customElements.get("quick-add") || customElements.define("quick-add", class extends HTMLElement {
      button=this.querySelector('button[type="submit"]');
      form=this.querySelector("form");
      handleClick(event) {
        event.preventDefault(), Shopify.addToCart(this.form);
      }
      constructor() {
        super();
      }
      connectedCallback() {
        this.button.addEventListener("click", (event => this.handleClick(event))), this.querySelectorAll("[data-quantity]").forEach((el => {
          el.addEventListener("click", (event => {
            event.preventDefault(), event.stopPropagation();
            let quantity = parseInt(this.parentNode.querySelector('[name="quantity"]').value);
            quantity = el.hasAttribute("data-minus") ? Math.max(1, quantity - 1) : quantity += 1, 
            this.closest(".shopify-section").querySelectorAll('[name="quantity"]').forEach((el => el.value = quantity));
          })), el.classList.remove("hidden");
        }));
      }
    }));
  }
} ]);